import initialState from './initialState';
import {studentTabActionTypes as types} from '../constants';

function currentEstimatedGradesReducer(state = initialState.binderStudents.currentEstimatedGrades, action) {
  switch (action.type) {
    case types.CURRENT_ESTIMATED_GRADE_LOAD_REQUEST:
      return {...state, isError: false, isLoading: true};

    case types.CURRENT_ESTIMATED_GRADE_LOAD_SUCCESS:
      return {...state, isError: false, isLoading: false, items: action.payload};

    case types.CURRENT_ESTIMATED_GRADE_LOAD_FAILURE:
      return {...state, isError: true, isLoading: false, error: action.error};

    default:
      return state;
  }
}

export default currentEstimatedGradesReducer;
